export const listOfNotifications = '/user-history/api/user/:id/notification';
export const notificationsAdd = '/property/user/:id/notification';
export const notificationsUpdate = '/property/user/:id/notification/:notification';
export const notificationsDelete = '/property/user/:id/notification/:notification';
export const notificationsChangeStatus = '/property/user/:id/notification/:notification/change-status';
